export default "__VITE_ASSET__12648112__"